import {
  // eslint-disable-next-line no-restricted-imports
  WizardStepper as WizardStepperDS,
  WizardStepperStep
} from "@packages/ds";

import WizardStepperWrapper from "./WizardStepperWrapper";

/**
 * Extended step type with path for routing
 */
export interface RoutableWizardStep extends WizardStepperStep {
  /** Path to navigate to when step is clicked */
  stepPath?: string;
}

export type { WizardStepperStep };

// Create a namespaced export with our router-aware WizardStepperWrapper
const ConsoleWizardStepper = {
  Step: WizardStepperDS.Step,
  WizardStepperWrapper
};

// Export each component individually
export const { Step } = ConsoleWizardStepper;
export { WizardStepperWrapper };

// Default export for namespace-style imports
export default ConsoleWizardStepper;
